<template>
  <div>
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      label-width="90px"
      :get-action="queryApi"
      :serial="serial"
      :stripe="false"
      :selection="selection"
      :height="height - 48"
      reset-btn-hide
      right-toolbar-hide
      tag-name="skuCode"
      show-tags
      tag-x
      :disabled="disabledNotSelected"
      row-key="id"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.spuCode')" prop="spuCode">
            <BjInput
              v-model="queryParams.spuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              placeholder="商品编码"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput
              v-model="queryParams.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              placeholder="SKU编码"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <el-table-column prop="spuCode" label="商品编码" width="150" align="center" />
        <el-table-column prop="skuCode" label="SKU编码" width="150" align="center" />
        <el-table-column prop="num" label="数量" width="50" align="center" />
        <el-table-column prop="spuName" label="商品名称" align="center" show-overflow-tooltip />
      </template>

      <template v-slot:paginationBottom>
        <BjDivider>
          包裹商品
          <template #right>
            <el-button type="primary" @click="onSearch">查询可发货逻辑仓</el-button>
          </template>
        </BjDivider>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {} from '@/utils/constants';

export default {
  name: 'BusinessOrderSourceAppointDeliveryParcelLeft',
  components: {},
  mixins: [pageMiXin],
  props: {
    height: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  inject: ['orderId'],
  data() {
    return {
      colSpan: 10,
      selection: true,
      queryApi: orderApi.getOrderSourcingSkuLineListByOrder,
      // 查询参数
      queryParams: {
        sourcingId: this.orderId(),
        spuCode: null,
      },
      goodsList: [],
    };
  },
  computed: {
    /** 选中数据处理 */
    tagList() {
      return this.tags.map(item => {
        return {
          id: item.id,
          skuCode: item.skuCode,
          skuName: item.skuName,
          number: item.count,
        };
      });
    },
    /** 包裹商品数 */
    goodsNum() {
      let goodsNum = 0;
      this.tagList.forEach(e => {
        goodsNum += e.number;
      });
      return goodsNum;
    },
    disabledNotSelected() {
      return this.disabled.filter(id => {
        return this.goodsList.every(row => row.id != id);
      });
    },
  },
  watch: {},
  created() {},
  methods: {
    onSearch() {
      if (this.tagList.length === 0) {
        this.$message.warning('包裹商品不能为空，请添加');
        return;
      }
      this.$emit('search', this.tagList, this.selectedRows);
    },
    reset(d) {
      this.goodsList = d || [];

      this.$refs.BjPage.setDefaultSelectedRows(this.goodsList);

      this.reFresh();
    },
  },
};
</script>
